/* import __COLOCATED_TEMPLATE__ from './teammate-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();